namespace RecordShield.Workspace {
    export interface KeyGenRow {
        Id?: number;
        Quantity?: number;
        Owner?: number;
        Product?: number;
        Status?: Modules.Workspace.SerialKeys.KeyStatus;
        IsActive?: number;
        OwnerName?: string;
        ProductName?: string;
        AccessStatus?: Modules.Workspace.SerialKeys.AccessStatus;
        Credit?: number;
        Size?: number;
        TotalAllowedDuration?: number;
        AllowedDevices?: Models.Enums.AllowedDevices;
        SerialKeyItems?: number[];
        TenantId?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace KeyGenRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Workspace.KeyGen';

        export namespace Fields {
            export declare const Id: string;
            export declare const Quantity: string;
            export declare const Owner: string;
            export declare const Product: string;
            export declare const Status: string;
            export declare const IsActive: string;
            export declare const OwnerName: string;
            export declare const ProductName: string;
            export declare const AccessStatus: string;
            export declare const Credit: string;
            export declare const Size: string;
            export declare const TotalAllowedDuration: string;
            export declare const AllowedDevices: string;
            export declare const SerialKeyItems: string;
            export declare const TenantId: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['Id', 'Quantity', 'Owner', 'Product', 'Status', 'IsActive', 'OwnerName', 'ProductName', 'AccessStatus', 'Credit', 'Size', 'TotalAllowedDuration', 'AllowedDevices', 'SerialKeyItems', 'TenantId', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
